export const PhoneRegex = (countryCode) => {
  if (['USA', 'IND', 'CAN', 'MEX', 'EGY', 'PHL'].includes(countryCode)) {
    return {
      regex: /^[\d]{10}$/,
      msg: 'Mobile/Primary Phone must contain 10 digits.'
    }
  }
  else if (countryCode == 'TTO') {
    return {
      regex: /^[\d]{7}$/,
      msg: 'Mobile/Primary Phone must contain 7 digits.'
    }
  }
  else if (countryCode == 'POL') {
    return {
      regex: /^[\d]{9}$/,
      msg: 'Mobile/Primary Phone must contain 9 digits.'
    }
  }
  else if (countryCode == 'HKG') {
    return {
      regex: /^[\d]{8}$/,
      msg: 'Mobile/Primary Phone must contain 8 digits.'
    }
  }
  //else if (countryCode == 'PHL') {
  //  return {
  //    regex: /^[0-9]{7,10}$/,
  //    msg: 'Mobile/Primary Phone must contain 7 to 10 digits.'
  //  }
  //}
  else if (countryCode == 'PAN') {
    return {
      regex: /^[0-9]{7,8}$/,
      msg: 'Mobile/Primary Phone must contain 7 to 8 digits.'
    }
  }
  else if (countryCode == 'AUS') {
    return {
      regex: /^[\d]{9}$/,
      msg: 'Mobile/Primary Phone must contain 9 digits.'
    }
  }
  else
    return null
}

export const string_trim = (value) => {
  if (typeof value == 'string'){
    return value.trim()
  }
  return value
}
